(function () {
  'use strict';

  /* @ngdoc object
   * @name hardSoftRule
   * @description
   *
   */
  angular
    .module('hardSoftRule', [
      'ui.router'
    ]);
}());
